'use strict';
angular.module('productManageMentWebsiteChannelModule', [
    'mangeProChannelCtrlModule',
    'productManageMentWebsiteChannelRouterModule'
]).
controller('productManageMentWebsiteChannelCtrl', ['$scope', '$timeout', '$rootScope', '$q', '$state', '$modal', '$stateParams', 'trsHttpService', 'modalDialog', 'productMangageMentWebsiteService', 'localStorageService', "globleParamsSet", "websiteService", "editingCenterService", "previewToolService", "sortOfChannelService", "trsspliceString", function($scope, $timeout, $rootScope, $q, $state, $modal, $stateParams, trsHttpService, modalDialog, productMangageMentWebsiteService, localStorageService, globleParamsSet, websiteService, editingCenterService, previewToolService, sortOfChannelService, trsspliceString) {
    initStatus();
    initData();
    /**
     * [getChnlRights description] 获取频道权限
     * @return {[type]} [description]
     */
    function getChnlRights() {
        productMangageMentWebsiteService.getRight($stateParams.site, "", "websetsite.channel").then(function(data) {
            $scope.status.right = data;
        });
    }
    //获取栏目操作权限结束 
    /**
     * [positionToChannel description]定位到频道
     * @return null [description]
     */
    $scope.positionToSite = function(siteMsg) {
        $state.go("manageconfig.productmanage.website.channel", { site: siteMsg.SITEID }, { reload: true });
    };
    /**
     * [clickSiteDirected description]点击频道重定向开始
     * @return null [description]
     */
    $scope.clickChnlDirected = function(item) {
        productMangageMentWebsiteService.getCloumnAccessAuthority(item.CHANNELID).then(function(data) {
            //將权限信息存入缓存，用于底部路由区加载使用开始
            localStorageService.remove("rightOperType_channel"); //初始化缓存
            localStorageService.set("rightOperType_channel", {
                type: data.router,
                data: data.data
            });
            //將权限信息存入缓存，用于底部路由区加载使用结束
            $state.go("manageconfig.productmanage.website." + data.router, {
                channel: item.CHANNELID,
                parentchnl: item.CHANNELID,
                status: item.STATUS
            }, { reload: true });
        });
    };
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }
    /**
     * [requestData description] 请求列表数据
     * @return {[type]} [description]
     */
    function requestData() {
        var defferd = $q.defer();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
            $scope.websiteItems = data.DATA;
            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
            $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
            defferd.resolve(data);
        });
        return defferd.promise;
    }
    /**
     * [searchChannelByName description] 检索
     * @return {[type]} [description]
     */
    $scope.searchChannelByName = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            $scope.params.methodname = "queryChannelsBySiteForCloud";
            $scope.params.ChnlDesc = $scope.searchChlName;
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
            });
        }
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.page = {
            ITEMCOUNT: 0,
            PAGESIZE: 20,
            CURRPAGE: 1,
            PAGECOUNT: 0,
            copyCurrPage: 1
        };
        $scope.params = {
            serviceid: "mlf_websiteconfig",
            methodname: "queryChannelsBySiteForCloud",
            SiteId: $stateParams.site,
            pageSize: $scope.page.PAGESIZE,
            currpage: $scope.page.CURRPAGE
        };
        $scope.status = {
            PmmWebsiteChnlSelected: $stateParams.websiteselect,
            statusOptions: [{
                name: "全部状态",
            }, {
                name: "启用",
                value: 0,
            }, {
                name: "停用",
                value: -1
            }],
            selectedArray: [],
            selectedStatus: [],
            right: {}, //栏目列表操作权限
            publishOptions: [
                { name: '仅发布首页', value: 1 },
                { name: '完全发布', value: 0 }
            ],
            status: $stateParams.status
        };
        $scope.status.selectStatus = $scope.status.statusOptions[0];
        $scope.data = {
            siteMsg: "",
        };
        getChnlRights();
    }
    /**
     * [selectAll description] 选中全部栏目
     * @return {[type]} [description]
     */
    $scope.selectAll = function() {
        $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.websiteItems.length ? [] : [].concat($scope.websiteItems);
        $scope.status.selectedStatus = $scope.status.selectedArray.length == 0 ? 0 : 1;
    };
    /**
     * [selectChannel description] 选中某个栏目
     * @param {[object]} [channel] [description] 栏目数据
     * @return {[type]} [description]
     */
    $scope.selectChannel = function(channel) {
        if ($scope.status.selectedArray.indexOf(channel) < 0) {
            $scope.status.selectedArray.push(channel);
            if (channel.STATUS == -1) {
                $scope.status.selectedStatus.push(channel.CHANNELID);
            }
        } else {
            $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(channel), 1);
            if (channel.STATUS == -1) {
                $scope.status.selectedStatus.splice($scope.status.selectedStatus.indexOf(channel.CHANNELID), 1);
            }
        }
    };
    /** [pageChanged description]: 翻页功能 */
    $scope.pageChanged = function() {
        $scope.page.copyCurrPage = $scope.page.CURRPAGE;
        $scope.params.currpage = $scope.page.CURRPAGE;
        requestData();
    };
    /** [selectPageNum description] 选择单页数据条数 */
    $scope.selectPageNum = function() {
        $scope.params.pageSize = $scope.page.PAGESIZE;
        requestData();
    };
    /** [jumpToPage description: 跳转到第几页] */
    $scope.jumpToPage = function() {
        $scope.page.CURRPAGE = $scope.page.copyCurrPage;
        $scope.params.currpage = $scope.page.CURRPAGE;
        requestData();
    };
    /**
     * [selectStatus description]根据状态筛选频道
     * @params [{}] [description]
     * @return null [description]
     */
    $scope.selectStatus = function() {
        $scope.params.status = $scope.status.selectStatus.value;
        requestData();
    };
    /**
     * [enableDisable description]启用停用频道
     * @return null [description]
     */
    $scope.enableDisable = function(websiteItem) {
        if (websiteItem.STATUS === '0') {
            $scope.disableSite(websiteItem);
        } else {
            $scope.reductionViews(websiteItem);
        }
    };
    /**
     * [disableSite description]停用频道
     * @return null [description]
     */
    $scope.disableSite = function(websiteItem) {
        var checkParams = {
            serviceid: "mlf_websiteconfig",
            methodname: "deleteChannelCondition",
            ChannelId: websiteItem.CHANNELID
        };
        var deleteParams = {
            serviceid: "mlf_websiteconfig",
            methodname: "deleteChannel",
            ChannelId: websiteItem.CHANNELID,
            TopChannelId: '0'
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, "post")
            .then(function(data) {
                modalDialog.inputModel("停用", "停用原因（选填）", function(data) {
                    productMangageMentWebsiteService.inputPassword(function(password) {
                        LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                            deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "post")
                                .then(function(data) {
                                    modalDialog.alertType("停用成功", "", "success", false);
                                    $state.go($state.current.name, $stateParams, { reload: true });
                                });
                        });
                    });
                });
            });
    };
    /**
     * [reductionViews description]启用频道
     * @params [{websiteItem}] [description] 频道信息
     * @return null [description]
     */
    $scope.reductionViews = function(websiteItem) {
        modalDialog.alertType("确定启用该频道？", "", "ask", true, function() {
            var reSiteParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "restoreChannels",
                ObjectIds: websiteItem.CHANNELID,
                SiteId: $stateParams.site,
                TopChannelId: '0',
                RestoreAll: false
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, "post")
                .then(function(data) {
                    modalDialog.alertType("启用成功", "", "success", false);
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
        });
    };
    /**
     * [batDelete description] 批量删除方法
     * @return {[type]} [description]
     */
    $scope.batDelete = function() {
        if ($scope.status.selectedArray.length == 0) {
            modalDialog.alertType("请先选择一个频道", "", "warning", false);
            return;
        } else {
            modalDialog.alertType("确定要删除选中的频道吗", "", "warning", true, function() {
                $scope.deleteViews($scope.status.selectedArray);
            });
        }
    };
    /**
     * [deleteSite description]删除频道
     * @params [{chnlId}] [description] 频道信息
     * @return null [description]
     */
    $scope.deleteViews = function(websiteItem) {
        $scope.selectChannelIds = trsspliceString.spliceString(websiteItem, "CHANNELID", ",");
        var ckConditionParamas = {
            serviceid: "mlf_websiteconfig",
            methodname: "checkChannelCondition",
            ChannelIds: $scope.selectChannelIds
        };
        var deleteParams = {
            serviceid: "mlf_websiteconfig",
            methodname: "removeChannels",
            ChannelIds: $scope.selectChannelIds,
            TopChannelId: '0',
            PassWord: ""
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, "get")
            .then(function(data) {
                productMangageMentWebsiteService.inputPassword(function(password) {
                    LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                        deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "get")
                            .then(function(data) {
                                modalDialog.alertType("删除成功", "", "success", false);
                                $state.go($state.current.name, $stateParams, { reload: true });
                            });
                    });
                });
            });
    };
    //修改弹窗
    $scope.modify = function(websiteItem) {
        var column = {
            title: "修改频道",
            isColumn: false
        };
        $scope.modifyViews(column, function(data) {

        }, websiteItem);
    };
    //新增弹窗
    $scope.add = function() {
        var column = {
            title: "新建频道",
            isColumn: false
        };
        $scope.modifyViews(column, function(data) {

        }, "");
    };
    //发布频道
    $scope.publish = function(item) {
        $scope.status.selectedPublishWay = item.value;
        $timeout(function() {
            if ($scope.status.selectedPublishWay === 1) $scope.publishHome($scope.status.selectedArray[0]);
            else $scope.publishFull($scope.status.selectedArray[0]);
        });
        //websiteService.websitePublish(websiteItem.CHANNELID, "101");
    };
    /**
     * [singlePublish description] 单个栏目发布
     * @param  {[type]} channel [description] 栏目数据
     * @return {[type]}      [description]
     */
    $scope.singlePublish = function(channel) {
        $timeout(function() {
            if ($scope.status.selectedPublishWay.value === 1) $scope.publishHome(channel);
            else $scope.publishFull(channel);
        });
    };

    /**
     * [sortOfSites description] 频道排序
     * @return {[type]} [description]
     */
    $scope.channelOfSites = function() {
        if ($scope.status.selectedArray.length !== 1) {
            modalDialog.alertType("请选择一个频道", "", "warning", false);
            return;
        }
        var index = $scope.websiteItems.indexOf($scope.status.selectedArray[0]) + 1;
        sortOfChannelService.sorts("website", index, $scope.status.selectedArray[0], $scope.websiteItems, function(data) {
            if (data.ISSUCCESS == "true") {
                $state.go($state.current.name, $stateParams, { reload: true });
            }

        });

    };


    /**
     * [addChildren description] 新增子站点
     */
    $scope.addChildren = function(channel) {
        var column = {
            title: "新增子栏目",
            isColumn: true
        };
        addColumn(column, channel, function() {});
    };

    function addColumn(column, channel, successFn) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/website/channel/template/channel_modify_tpl.html",
            windowClass: 'productManageMent-website-channel-modify',
            backdrop: false,
            controller: "columnModifyCtrl",
            resolve: {
                column: function() {
                    return column;
                },
                successFn: function() {
                    return successFn;
                },
                websiteChannel: function() {
                    return "";
                },
                selfChannel: function() {
                    return channel;
                }
            }
        });
        return modalInstance.result.then(function(params) {
            params.serviceid = "mlf_websiteconfig";
            params.methodname = "saveNewChnl";
            params.TopChannelId = channel.CHANNELID;
            params.CHNLDATAPATH = params.DATAPATH;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function() {
                modalDialog.alertType('新增子栏目成功', "", "success", false);
                $state.go($state.current.name, $stateParams, { reload: true });
            });
        });
    }
    //修改弹窗方法
    $scope.modifyViews = function(column, successFn, websiteChannel) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/website/channel/template/channel_modify_tpl.html",
            windowClass: 'productManageMent-website-channel-modify',
            backdrop: false,
            controller: "channelModifyCtrl",
            resolve: {
                column: function() {
                    return column;
                },
                successFn: function() {
                    return successFn;
                },
                websiteChannel: function() {
                    return websiteChannel;
                }
            }
        });
        modalInstance.result.then(function(result) {
            var params = result;
            params.serviceid = "mlf_websiteconfig";
            params.methodname = "saveNewChnl";
            params.TopChannelId = '0';
            params.CHNLDATAPATH = result.DATAPATH;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var defferd = $q.defer();
                if (data) {
                    modalDialog.alertType(column.title + '成功', "", "success", false);
                    $state.go($state.current.name, $stateParams, { reload: true });
                }
                return defferd.promise;
            }).then(function(data) {
                requestData();
            });
        });
    };
    //频道预览
    $scope.preview = function(websiteItem) {
        previewToolService.channelPreview(websiteItem);
    };
    //发布到首页
    $scope.publishHome = function(websiteItem) {
        if (!websiteItem.right.channel.solopublish) {
            modalDialog.alertType('您没有该频道的仅发布首页权限', '', 'warning', 'confirm');
            return;
        }
        modalDialog.alertType('确认发布该频道首页吗？', '', 'ask', true, () => {
            websiteService.websitePublish(websiteItem.CHANNELID, "101");
        });
    };
    //完全发布
    $scope.publishFull = function(websiteItem) {
        if (!websiteItem.right.channel.publish) {
            modalDialog.alertType('您没有该频道的完全发布权限', '', 'warning', 'confirm');
            return;
        }
        modalDialog.alertType('确认完全发布该频道吗？', '', 'ask', true, () => {
            var publishParams = {
                serviceid: "mlf_publish",
                methodname: "fullyPublish",
                ObjectIds: websiteItem.CHANNELID,
                ObjectType: '101',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), publishParams, "post").then(
                function(data) {
                    modalDialog.alertType("发布成功", "", "success", false);
                });
        });
    };
    /**
     * [getChildren description] 获取频道本身的权限
     * @param  {[type]} item [description] 频道数据
     * @return {[type]}      [description]
     */
    $scope.getChildrenRight = function(item) {
        productMangageMentWebsiteService.getRight($stateParams.site, "", "websetsite.channel").then(function(data) {
            item.right = data;
        });
    };
    /**
     * [addChildren description] 新建子栏目
     * @return {[type]}      [description]
     */
    $scope.batAddChildren = function() {
        if ($scope.status.selectedArray.length !== 1) {
            modalDialog.alertType("请选择一个频道", "", "warning", false);
            return;
        }
        if (!$scope.status.selectedArray[0].right.channel || !$scope.status.selectedArray[0].right.channel.add) {
            modalDialog.alertType("您没有该频道的新增权限", "", "warning", false);
            return;
        }
        $scope.addChildren($scope.status.selectedArray[0]);
    };
}]);